import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import AppRoot from "./AppRoot.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);
